<form [formGroup]="afdrachtsVerminderingFg">
  <div>
    <div class="row">
      <div class="col col-1">
        <p>Vermindering dividendbelasting art. 11 Wet DB</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="bedragVerminderingArtikel11"
                                          id="bedragVerminderingArtikel11"
                                          class=" custom-input-150"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          (change)="saveForm()"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </div>
  <div>
    <div class="row">
      <div class="col col-1">
        <p>Ingehouden dividendbelasting art. 11a Wet DB</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="bedragIngehoudenBelastingArtikel11a"
                                          id="bedragIngehoudenBelastingArtikel11a"
                                          class="custom-input-150"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          (change)="saveForm()"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </div>
  <div>
    <div class="row">
      <div class="col col-1">
        <p>Ingehouden buitenlandse bronbelasting art. 11a Wet DB</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="bedragIngehoudenBuitenlandseBronbelasting"
                                          id="bedragIngehoudenBuitenlandseBronbelasting"
                                          class="custom-input-150"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          (change)="saveForm()"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </div>
  <div>
    <div class="row">
      <div class="col col-1">
        <p>Ingehouden dividendbelasting art. 12 Wet DB</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="bedragIngehoudenBelastingArtikel12"
                                          id="bedragIngehoudenBelastingArtikel12"
                                          class="custom-input-150"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          (change)="saveForm()"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </div>
  <div>
    <div class="row">
      <div class="col col-1">
        <p>Afdrachtvermindering art. 12 Wet DB</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control formControlName="bedragVerminderingArtikel12"
                                          id="bedragVerminderingArtikel12"
                                          class="custom-input-150"
                                          align="right"
                                          prefix="€"
                                          [showAllDecimals]="false"
                                          (change)="saveForm()"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </div>
</form>
